import { createContext } from 'react';
var AxisContext = createContext();
AxisContext.displayName = 'AxisContext';
export default AxisContext;